import { Component, Inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { tap, take } from 'rxjs/operators';

import { AlertTypes, NoneAlert } from './alert.actions';
import { MatSnackBarRef, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

@Component({
  selector: 'mojo-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
})
export class AlertComponent {
  alertTypes = AlertTypes;

  constructor(
    private store: Store<{}>,
    private matSnackBarRef: MatSnackBarRef<AlertComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public data: any,
  ) {
    matSnackBarRef
      .afterDismissed()
      .pipe(
        take(1),
        tap(() => this.store.dispatch(new NoneAlert())),
      )
      .subscribe();
  }

  close() {
    this.matSnackBarRef.dismiss();
  }
}
